export interface User {
    Role: string;
    Email: string;
    WWID: string;
}

export const users: User[] = [
    { Role: "g_psbu_admin", Email: "", WWID: "fa643@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "lr957@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "as583@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "ga379@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "lc982@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "iu821@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "ni056@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "id810@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "kx057@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "iw798@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "ct414@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "ie688@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "ey413@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "ob612@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "ku580@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "ez225@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "hy354@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "kx458@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "gp078@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "ct896@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "hx854@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "oq665@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "uf569@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "fu622@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "iz619@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "dj326@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "gp970@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "ls054@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "nr336@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "rw905@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "ca229@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "rb857@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "lh202@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "bc295@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "ud337@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "wi127@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "hs328@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "ju806@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "ma299@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "ni357@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "ok070@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "rb567@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "wx429@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "kn109@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "ni272@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "th971@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "pn549@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "rk617@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "ia544@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "wf979@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "ks583@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "la970@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "ib438@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "aw901@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "fm103@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "fc323@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "fe700@cummins.com" },
    { Role: "g_psbu_admin", Email: "ayodeji.adelana@cummins.com", WWID: "" },
    { Role: "g_psbu_admin", Email: "", WWID: "il302@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "is054@cummins.com" },
    { Role: "g_psbu_admin", Email: "daisy.wang@cummins.com", WWID: "" },
    { Role: "g_psbu_admin", Email: "", WWID: "ie998@cummins.com" },
    { Role: "g_psbu_admin", Email: "edwin.van.plaggenhoef@cummins.com", WWID: "" },
    { Role: "g_psbu_admin", Email: "", WWID: "co765@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "dh665@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "pf153@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "kz067@cummins.com" },
    { Role: "g_psbu_admin", Email: "jason.chong@cummins.com", WWID: "" },
    { Role: "g_psbu_admin", Email: "", WWID: "ss540@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "gx304@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "nt247@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "oo229@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "ga506@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "fy884@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "jd753@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "qp659@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "ox826@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "qc570@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "my521@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "pb641@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "on505@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "nc915@cummins.com" },
    { Role: "g_psbu_admin", Email: "thomas.stephen@cummins.com", WWID: "" },
    { Role: "g_psbu_admin", Email: "", WWID: "oj197@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "hf276@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "ma008@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "lw865@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "ni401@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "kz092@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "cr794@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "ct578@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "fn082@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "gl954@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "ck780@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "kc047@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "iu529@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "rq934@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "wh453@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "jf960@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "af843@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "lb273@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "cj968@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "fm037@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "ft700@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "bs978@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "kl337@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "mx927@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "in468@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "wa075@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "iv295@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "rf185@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "ie588@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "bm342@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "ci746@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "ra686@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "st833@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "qc356@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "rw814@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "tq484@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "rd439@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "pb400@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "vz067@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "gk753@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "gf947@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "um446@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "sd914@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "qb028@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "tp4479@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "op556@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "wi170@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "mn106@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "vr100@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "mq837@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "fw129@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "ap178@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "rc139@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "ks427@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "ke850@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "ty100@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "ml186@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "gp434@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "qg340@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "tm530@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "kc611@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "df719@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "hx672@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "rm620@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "pt409@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "kg580@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "km948@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "al47p@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "je870@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "ij345@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "vq378@cummins.com" },
    { Role: "g_psbu_admin", Email: "", WWID: "ak26l@cummins.com" },
    { Role: "g_psbu_admin", Email: "archana.ravunniarath@cummins.com", WWID: "nh701@cummins.com" },
    { Role: "g_psbu_admin", Email: "prakash.kumar.d@cummins.com", WWID: "aw66c@cummins.com" },
    { Role: "g_psbu_admin", Email: "anand.kumar3@cummins.com", WWID: "vt981@cummins.com" },
    { Role: "g_psbu_admin", Email: "prajwal.kk@simadvisorytech.com", WWID: "" },
    { Role: "g_psbu_admin", Email: "henrique.cubarenco@cummins.com", WWID: "fl856@cummins.com" },
];

const normalizeIdentityValue = (value?: string | null): string | null => {
    const normalizedValue = value?.trim().toLowerCase();
    return normalizedValue || null;
};

export const getMappedRoleByEmail = (email?: string | null): string | null => {
    const normalizedEmail = normalizeIdentityValue(email);
    const matchedUser = users.find(
        (user) => !!normalizedEmail && normalizeIdentityValue(user.Email) === normalizedEmail,
    );
    return matchedUser?.Role ?? null;
};

export const getMappedRoleForUser = (identity?: {
    email?: string | null;
    wwid?: string | null;
    username?: string | null;
}): string | null => {
    if (!identity) {
        return null;
    }

    const normalizedEmail = normalizeIdentityValue(identity.email);
    const normalizedUsername =
        normalizeIdentityValue(identity.username) ||
        normalizeIdentityValue(identity.wwid);

    const matchedUser = users.find((user) => {
        const userEmail = normalizeIdentityValue(user.Email);
        const userWwid = normalizeIdentityValue(user.WWID);

        return (
            (!!normalizedEmail && userEmail === normalizedEmail) ||
            (!!normalizedUsername && userWwid === normalizedUsername)
        );
    });

    return matchedUser?.Role ?? null;
};
